/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropertyOut
 */
export interface PropertyOut {
    /**
     * 
     * @type {number}
     * @memberof PropertyOut
     */
    propertyId: number;
    /**
     * 
     * @type {Date}
     * @memberof PropertyOut
     */
    modificationDate: Date;
}

export function PropertyOutFromJSON(json: any): PropertyOut {
    return PropertyOutFromJSONTyped(json, false);
}

export function PropertyOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyOut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'propertyId': json['propertyId'],
        'modificationDate': (new Date(json['modificationDate'])),
    };
}

export function PropertyOutToJSON(value?: PropertyOut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'propertyId': value.propertyId,
        'modificationDate': (value.modificationDate.toISOString()),
    };
}


